/* Mini-cart variant B — offers / coupons (markup: snippets/mini-cart-offers-b.liquid).

   Apply / Remove / manual code all go through the cart API, same pattern as custom-pack-selector.js:
     GET /cart.js → build the new code list → POST /cart/update.js { discount, sections: 'mini-cart' }
   Policy: ONE code at a time — applying a code replaces any code already on the cart. Automatic
   discounts are never touched (the cart API can't add or remove them).
   A code Shopify reports as not applicable is rolled back to the previous codes and an error shown.
   A code that stops being applicable after a later cart change is removed (pruneInapplicable).

   The drawer re-renders from the returned section HTML via the usual cart:refresh event, so every
   card's state (applied / saved amount / eligible) is recomputed server-side.
   Handlers are delegated on document, so they survive the drawer's innerHTML swaps. */
(function () {
  'use strict';

  if (window.__mcOffersInit) return;
  window.__mcOffersInit = true;

  var busy = false;

  function drawer() { return document.getElementById('mini-cart'); }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function cartCodes(cart) {
    return ((cart && cart.discount_codes) || [])
      .map(function (d) { return d && d.code; })
      .filter(Boolean);
  }

  function sameCode(a, b) { return String(a).trim().toUpperCase() === String(b).trim().toUpperCase(); }

  function setCodes(codes) {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ discount: codes.join(','), sections: 'mini-cart' })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart/update ' + r.status);
      return r.json();
    });
  }

  function refreshDrawer(cart) {
    var root = document.documentElement;
    root.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
    root.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
  }

  /* Small toast — lives on <body> so drawer re-renders don't wipe it */
  var toastTimer;
  function toast(msg, isError) {
    var el = document.getElementById('mc-offers-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'mc-offers-toast';
      el.className = 'mc-offers-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.toggle('mc-offers-toast--error', !!isError);
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 2600);
  }

  function setBusy(btn, on) {
    if (!btn) return;
    if (on) {
      btn.dataset.label = btn.textContent;
      btn.textContent = '…';
      btn.disabled = true;
    } else if (btn.isConnected) {
      btn.textContent = btn.dataset.label || btn.textContent;
      btn.disabled = false;
      if (btn.hasAttribute('data-mc-offer-manual-btn')) syncManualBtn(btn.closest('[data-mc-offer-manual]'));
    }
  }

  /* Manual-code Apply is disabled (50% opacity) until something is typed */
  function syncManualBtn(form) {
    if (!form) return;
    var input = form.querySelector('input[name="code"]');
    var btn = form.querySelector('[data-mc-offer-manual-btn]');
    if (btn) btn.disabled = !(input && input.value.trim());
  }

  function showManualError(msg) {
    var el = document.querySelector('#mini-cart [data-mc-offer-error]');
    if (!el) return;
    el.textContent = msg || '';
    el.hidden = !msg;
  }

  function publish(name, data) {
    if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
      try { Shopify.analytics.publish(name, data); } catch (e) {}
    }
  }

  /* MoEngage, one event per button press, sent before the cart is changed so codes that turn out invalid count too:
       coupon_apply_btn     — Apply on a coupon card (strip or View all panel)
       manual_coupon_input  — Apply on the typed-in code (View all panel form)
       coupon_remove_btn    — Remove on an applied coupon card (strip or View all panel)
       coupon_view_all_btn  — "View all" on the Coupons row (opens the panel)
       coupon_copy_btn      — the code chip on a coupon card (View all panel), copies the code
     Every event carries cart_token + session_id; attrs adds the rest. window.moeTrack comes from
     snippets/moe-track (theme.liquid). cart_token is Shopify's cart id with its ?key= access secret
     dropped — the same value as an order's cart_token, so presses can be joined to orders. */
  function trackCoupon(name, cart, attrs) {
    if (typeof window.moeTrack !== 'function') return;
    try {
      attrs = attrs || {};
      attrs.cart_token = cart && cart.token ? String(cart.token).split('?')[0] : null;
      attrs.session_id = window.phdMoeSessionId ? window.phdMoeSessionId() : null;
      window.moeTrack(name, attrs);
    } catch (e) {}
  }

  function applyCode(code, btn, source) {
    code = String(code || '').trim();
    if (!code || busy) return;
    busy = true;
    setBusy(btn, true);
    showManualError('');

    var previous = [];
    getCart()
      .then(function (cart) {
        trackCoupon(source === 'manual' ? 'manual_coupon_input' : 'coupon_apply_btn', cart, {
          coupon_code: code.toUpperCase(),
          source: source
        });
        previous = cartCodes(cart);
        if (previous.length === 1 && sameCode(previous[0], code)) return { cart: cart, already: true };
        return setCodes([code]).then(function (updated) { return { cart: updated }; });   // replace
      })
      .then(function (res) {
        if (res.already) { toast(code.toUpperCase() + ' is already applied'); return; }
        var entry = (res.cart.discount_codes || []).filter(function (d) { return sameCode(d.code, code); })[0];
        if (!entry || entry.applicable === false) {
          // Not valid: put the previous codes back. The cart ends up exactly as before, so the drawer
          // already shows the right state — no refresh (and the inline error isn't wiped by a re-render).
          return setCodes(previous).then(function () {
            var msg = code.toUpperCase() + " isn't valid for this cart";
            toast(msg, true);
            if (source === 'manual') showManualError(msg);
            publish('mc_offer_apply', { code: code, status: 'invalid', source: source });
          });
        }
        refreshDrawer(res.cart);
        toast(code.toUpperCase() + ' applied');
        publish('mc_offer_apply', { code: code, status: 'applied', source: source });
      })
      .catch(function (err) {
        console.error('[mc-offers] apply failed', err);
        toast('Could not apply the code. Please try again.', true);
      })
      .finally(function () { busy = false; setBusy(btn, false); });
  }

  function removeCode(code, btn, source) {
    if (!code || busy) return;
    console.log('[mc-offers] remove', code, source);
    busy = true;
    setBusy(btn, true);
    getCart()
      .then(function (cart) {
        trackCoupon('coupon_remove_btn', cart, {
          coupon_code: String(code).toUpperCase(),
          source: source
        });
        var rest = cartCodes(cart).filter(function (c) { return !sameCode(c, code); });
        return setCodes(rest);
      })
      .then(function (cart) {
        refreshDrawer(cart);
        toast(String(code).toUpperCase() + ' removed');
        publish('mc_offer_remove', { code: code });
      })
      .catch(function (err) {
        console.error('[mc-offers] remove failed', err);
        toast('Could not remove the code. Please try again.', true);
      })
      .finally(function () { busy = false; setBusy(btn, false); });
  }

  /* Every cart change (qty +/-, remove, add to cart, back from checkout…) fires cart:updated with the
     fresh cart. Any code Shopify now reports as not applicable (e.g. qty dropped below the coupon's
     threshold) is taken off the cart. Listens to cart:updated, not cart:refresh: sections/mini-cart.liquid
     stops cart:refresh from reaching later listeners.
     Skipped while an apply/remove is running — those set the codes themselves. The cart:updated fired by
     the refresh below has only applicable codes left, so it doesn't start another round. */
  function pruneInapplicable(cart) {
    if (busy) return;
    var entries = ((cart && cart.discount_codes) || []).filter(function (d) { return d && d.code; });
    var dead = entries.filter(function (d) { return d.applicable === false; }).map(function (d) { return d.code; });
    if (!dead.length) return;
    var keep = entries.filter(function (d) { return d.applicable !== false; }).map(function (d) { return d.code; });    
    busy = true;
    setCodes(keep)
      .then(function (updated) {
        refreshDrawer(updated);
        toast(dead.join(', ').toUpperCase() + ' removed — not valid for this cart');
        publish('mc_offer_auto_remove', { codes: dead });
      })
      .catch(function (err) { console.error('[mc-offers] auto-remove failed', err); })
      .finally(function () { busy = false; });
  }

  document.documentElement.addEventListener('cart:updated', function (e) {
    pruneInapplicable(e.detail && e.detail.cart);
  });

  /* "View all" overlay: state lives as an attribute on the drawer element itself, which survives the
     drawer's innerHTML swaps, so the panel stays open while cards re-render underneath */
  function setPanel(open) {
    var d = drawer();
    if (!d) return;
    if (open) d.setAttribute('data-offers-open', '');
    else d.removeAttribute('data-offers-open');
    if (open) {
      var back = d.querySelector('[data-mc-offers-close]');
      if (back) back.focus();
    }
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var el;
    if ((el = t.closest('#mini-cart [data-mc-offer-apply]'))) {
      e.preventDefault();
      if (!el.disabled) applyCode(el.getAttribute('data-mc-offer-apply'), el, el.closest('.mc-offers-panel') ? 'panel' : 'strip');
    } else if ((el = t.closest('#mini-cart [data-mc-offer-remove]'))) {
      e.preventDefault();
      removeCode(el.getAttribute('data-mc-offer-remove'), el, el.closest('.mc-offers-panel') ? 'panel' : 'strip');
    } else if ((el = t.closest('#mini-cart [data-mc-offer-copy]'))) {
      e.preventDefault();
      var code = el.getAttribute('data-mc-offer-copy');
      var copyAttrs = { coupon_code: String(code).toUpperCase(), source: el.closest('.mc-offers-panel') ? 'panel' : 'strip' };
      // Sent on every press, whether or not the clipboard write works; the cart is only fetched for its token
      getCart()
        .then(function (cart) { trackCoupon('coupon_copy_btn', cart, copyAttrs); })
        .catch(function () { trackCoupon('coupon_copy_btn', null, copyAttrs); });
      if (navigator.clipboard) navigator.clipboard.writeText(code).then(function () { toast(code + ' copied'); });
    } else if (t.closest('#mini-cart [data-mc-offers-open]')) {
      e.preventDefault();
      setPanel(true);
      // Panel opens right away; the cart is only fetched for its token. If that fails, still send the event.
      getCart()
        .then(function (cart) { trackCoupon('coupon_view_all_btn', cart); })
        .catch(function () { trackCoupon('coupon_view_all_btn', null); });
    } else if (t.closest('#mini-cart [data-mc-offers-close]')) {
      e.preventDefault();
      setPanel(false);
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('#mini-cart [data-mc-offer-manual]');
    if (!form) return;
    e.preventDefault();
    var input = form.querySelector('input[name="code"]');
    var value = input ? input.value.trim() : '';
    if (!value) { showManualError('Enter a coupon code'); return; }
    applyCode(value, form.querySelector('button[type="submit"]'), 'manual');
  });

  document.addEventListener('input', function (e) {
    var form = e.target.closest && e.target.closest('#mini-cart [data-mc-offer-manual]');
    if (!form) return;
    syncManualBtn(form);
    showManualError('');              // clear the old error as soon as they edit the code
  });

  document.addEventListener('keydown', function (e) {
    var d = drawer();
    if (e.key === 'Escape' && d && d.hasAttribute('data-offers-open')) {
      e.stopPropagation();       // close the panel, not the whole drawer
      setPanel(false);
    }
  }, true);

  /* Drawer closed → reset the panel so it reopens on the cart */
  function watchDrawer() {
    var d = drawer();
    if (!d || !window.MutationObserver) return;
    new MutationObserver(function () {
      if (!d.hasAttribute('open')) d.removeAttribute('data-offers-open');
    }).observe(d, { attributes: true, attributeFilter: ['open'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchDrawer);
  else watchDrawer();
})();
